export function createParticipantSelectionGuard() {
  let sequence = 0

  return {
    next() {
      sequence += 1
      return sequence
    },
    isCurrent(value) {
      return value === sequence
    },
  }
}
